import { render } from "./EditExtraction.vue?vue&type=template&id=53214b2a&scoped=true"
import script from "./EditExtraction.vue?vue&type=script&lang=js"
export * from "./EditExtraction.vue?vue&type=script&lang=js"

import "./EditExtraction.vue?vue&type=style&index=0&id=53214b2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53214b2a"]])

export default __exports__